/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Office_HeadingInputs */

const en_contact_office_heading = /** @type {(inputs: Contact_Office_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered office`)
};

/**
* | output |
* | --- |
* | "Registered office" |
*
* @param {Contact_Office_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_office_heading = /** @type {((inputs?: Contact_Office_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Office_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_office_heading(inputs)
});